export default {"src":"/_next/static/media/Off.9a6fb89f.svg","height":16,"width":16};